export interface ThemeType {
  // Main
  main: string;
  onMain: string;
  mainHover: string;
  lightMain: string;

  // Sub
  sub: string;
  onSub: string;
  subHover: string;

  // Accent
  accent: string;
  accentHover: string;
  onAccent: string;

  // Backgrounds
  bgCanvas: string;
  bgElevated: string;
  bgMuted: string;

  // Inputs
  bgInput: string;
  fgInput: string;
  placeholderInput: string;
  inputBorder: string;

  // Special inputs (like the link creation inputs)
  bgSpecialInput: string;
  fgSpecialInput: string;
  placeholderSpecialInput: string;
  inputBorderSpecialInput: string;

  // Content
  fgPrimary: string;
  fgSecondary: string;
  fgDisabled: string;
  fgMuted: string;

  // Borders & Dividers
  bdSubtle: string;
  bdDefault: string;
  bdStrong: string;
  ringFocus: string;

  // Icons
  iconPrimary: string;
  iconSecondary: string;
  iconDisabled: string;

  // Semantic States
  success: string;
  onSuccess: string;
  warning: string;
  onWarning: string;
  danger: string;
  onDanger: string;
  info: string;
  onInfo: string;

  // Links
  link: string;
  linkHover: string;

  // Other
  transparent: string;
}
/* eslint-disable */
export const LightTheme: ThemeType = {
  // Main
  main: '#652d90',
  onMain: '#ebebeb',
  mainHover: '#934599',
  lightMain: '#934599',

  // Sub
  sub: '#ebebeb',
  onSub: '#652d90',
  subHover: '#d6d6d6',

  // Accent
  accent: '#2b2694',
  accentHover: '#3b34c6',
  onAccent: '#fff',

  // Backgrounds
  bgCanvas: '#fff',
  bgElevated: '#ebebeb',
  bgMuted: '#d6d6d6',

  // Inputs
  bgInput: '#ffffff',
  fgInput: '#000000',
  placeholderInput: '#000000',
  inputBorder: '#ebebeb',

  // Special inputs (like the link creation inputs)
  bgSpecialInput: '#d6d6d6',
  fgSpecialInput: '#343434',
  placeholderSpecialInput: '#818181',
  inputBorderSpecialInput: '#343434',

  // Content
  fgPrimary: '#000000',
  fgSecondary: '#5c5b5b',
  fgDisabled: '#e8eaea',
  fgMuted: '#818181',

  // Borders & Dividers
  bdSubtle: '#d4d2d2',
  bdDefault: '#434343',
  bdStrong: '#222222',
  ringFocus: '#904ac7',

  // Icons
  iconPrimary: '#5c5b5b',
  iconSecondary: '#000000',
  iconDisabled: '#7f7f7f',

  // Semantic States
  success: '#0f0',
  onSuccess: '#000',
  warning: '#ffa500',
  onWarning: '#000',
  danger: '#f00',
  onDanger: '#fff',
  info: '#934599',
  onInfo: '#fff',

  // Links
  link: '#652d90',
  linkHover: '#c72cf4',

  // Other
  transparent: 'transparent',
};
// eslint-disable
export const DarkTheme: ThemeType = {
  // Main
  main: '#9b5cff',
  onMain: '#ffffff',
  mainHover: '#c08cff',
  lightMain: '#c08cff',

  // Sub
  sub: '#d1baff',
  onSub: '#2c2c2c',
  subHover: '#e5d4ff',

  // Accent
  accent: '#8a8aff',
  accentHover: '#b0b0ff',
  onAccent: '#ffffff',

  // Backgrounds
  bgCanvas: '#2e2e2e',
  bgElevated: '#383838',
  bgMuted: '#4a4a4a',

  // Inputs
  bgInput: '#3b3b3b',
  fgInput: '#e0e0e0',
  placeholderInput: '#a0a0a0',
  inputBorder: '#5c5c5c',

  // Special inputs
  bgSpecialInput: '#3b3b3b',
  fgSpecialInput: '#e0e0e0',
  placeholderSpecialInput: '#a0a0a0',
  inputBorderSpecialInput: '#5c5c5c',

  // Content
  fgPrimary: '#ffffff',
  fgSecondary: '#c0c0c0',
  fgDisabled: '#7f7f7f',
  fgMuted: '#a0a0a0',

  // Borders & Dividers
  bdSubtle: '#6b6b6b',
  bdDefault: '#555555',
  bdStrong: '#3a3a3a',
  ringFocus: '#c08cff',

  // Icons
  iconPrimary: '#ffffff',
  iconSecondary: '#c0c0c0',
  iconDisabled: '#7f7f7f',

  // Semantic States
  success: '#00d176',
  onSuccess: '#121212',
  warning: '#ffa500',
  onWarning: '#121212',
  danger: '#f44336',
  onDanger: '#ffffff',
  info: '#934599',
  onInfo: '#ffffff',

  // Links
  link: '#9b5cff',
  linkHover: '#c08cff',

  // Other
  transparent: 'transparent',
};
